import React from "react";

import { UnwrapReactComponent } from "../../../utils/fp/missing-ts-parts";
import { TwoColumnGrid } from "./TwoColumnGrid";
import { SerializedStyles } from "@emotion/react";

export const EqualSizeGrid: React.FC<
  Omit<UnwrapReactComponent<typeof TwoColumnGrid>, "ratio"> & { attachStyles?: SerializedStyles }
> = props => <TwoColumnGrid ratio={[1, 1]} {...props} />;
